module.exports = __webpack_public_path__ + "img/tabbed-search-filter-hyundai.fb560b6c.png";